import './sib-new-arena-sectors.scss';

import { WpArenaSectors, WpPayConfirm } from '../../components';
import Component, { mixins } from 'vue-class-component';
import GlobalService, {
    ArenaSector, SibIdentity, SibSymbols, IdentityChangedEventArgs,
    ICartService, CartSymbols, ISibProvider, ErrorTypes
} from 'web-platform-core-ui';
import { Ref } from 'vue-property-decorator';
import { WpArenaSectorsDictionary } from '../../components/WpSale/WpArena/WpArenaSectors/wp-arena-sectors';

@Component({
    template: require("./sib-new-arena-sectors.html")
})
export default class SibNewArenaSectors extends WpArenaSectors {
    AuthModal: boolean = false;
    Context?: SibIdentity;
    CurrentSector?: ArenaSector;
    SibIdSelected: boolean = false;


    @Ref('PhoneForm') _phoneForm!: HTMLFormElement;
    Phone: string = '+7(';
    PhoneValid: boolean = false;
    IsSendingPhone: boolean = false;
    SelectedFanId: string = '';
    FanIds: Array<any> = []

    get PhoneRules() {
        return [
            (v: string) => (/^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){11,14}(\s*)?$/.test(v)) || `${(this.Terms as WpSibSectorsDictionary).EnterPhoneError}`
        ];
    }
    PhoneFocus(): void {
        if (this.Phone === '') {
            this.Phone = '+7(';
        }
    }
    async PhoneFormSubmit(e: any) {
        e.preventDefault();
        await this.SearchFan();
    }

    created() {
        let terms = this.Terms as any;
        if (terms.SibTitle == null) {
            terms.SibTitle = "Выберите карту болельщика";
            terms.PhoneLblText = "Введите номер телефона";
            terms.EnterPhoneError = "Введите номер";
            terms.SelectBtnText = "Выбрать";
            terms.FanNotFoundError = "Карта болельщика не найдена";

            this.Terms = terms;
        }
    }

    async SearchFan() {
        this.IsSendingPhone = true;

        let sibProvider = this.GlobalService.Get<ISibProvider>(SibSymbols.SibProvider);

        let searchResult = await sibProvider.SearchFanIdByPhoneAsync(this.Phone);
        if (!searchResult.Success || searchResult.Data == null) {

            if (searchResult.ErrorType == ErrorTypes.NotFoundData)
                this._notificationService.Error("", (this.Terms as WpSibSectorsDictionary).FanNotFoundError);
            else
                this._notificationService.Error("", searchResult.ErrorMessage != null &&
                    searchResult.ErrorMessage != '' ? searchResult.ErrorMessage : this.Terms.InternalError);
            this.IsSendingPhone = false;
            return;
        }

        let fan = { Phone: this.Phone, FanId: searchResult.Data };
        this.FanIds.push(fan);
        let store = JSON.stringify(this.FanIds);

        try {
            localStorage.setItem("wp-fans", store);
            localStorage.setItem(this.Phone, WpPayConfirm.WpPhoneConfirmKey);
        } catch { }

        this.SelectedFanId = fan.FanId;
        this.IsSendingPhone = false;
        this.Phone = '+7(';
    }


    async SectorSelected(sector: ArenaSector) {
        this.Context = this.GlobalService.Get<SibIdentity>(SibSymbols.SibContext);

        if (this.SibIdSelected) {
            this.$emit("SectorSelected", { Sector: sector, ArenaText: this.SectorsList.ArenaText, ArenaPosition: this.SectorsList.ArenaPosition });
            return;
        }

        try {
            let store = localStorage.getItem("wp-fans");
            if (store != null) this.FanIds = JSON.parse(store);
        } catch { }

        this.CurrentSector = sector;
        this.AuthModal = true;
    }

    async PolygonSelected(sector: ArenaSector) {
        this.Context = this.GlobalService.Get<SibIdentity>(SibSymbols.SibContext);

        if (this.SibIdSelected) {
            this.$emit("SectorSelected", { Sector: sector, ArenaText: this.SectorsList.ArenaText, ArenaPosition: this.SectorsList.ArenaPosition });
            return;
        }

        try {
            let store = localStorage.getItem("wp-fans");
            if (store != null) this.FanIds = JSON.parse(store);
        } catch { }

        this.CurrentSector = sector;
        this.AuthModal = true;
    }

    async SelectFandId() {
        GlobalService.GetSettings().SibId = this.SelectedFanId;
        this.SibIdSelected = true;
        if (this.CurrentSector != null)
            this.SectorSelected(this.CurrentSector);
        this.AuthModal = false;
    }
}


export class WpSibSectorsDictionary extends WpArenaSectorsDictionary {
    SibTitle: string = "Выберите карту болельщика";
    PhoneLblText: string = "Введите номер телефона";
    EnterPhoneError: string = "Введите номер";
    SelectBtnText: string = "Выбрать";
    FanNotFoundError: string = "Карта болельщика не найдена";
}
